import { inject } from '../utils';

class MojitoService {
  constructor(apiFactory, session) {
    this.session = session;
    this.http = apiFactory('/mojito');
  }

  getChatUrl(url = '') {
    return `/chat/affiliates/${this.session.getAffiliateId()}${url}`;
  }

  ensureUserExist() {
    const options = {
      headers: {
        'Content-Type': 'text/plain',
      },
    };

    return this.http.post(this.getChatUrl('/me', null, options));
  }

  async ensureChannelExist(reservationId) {
    const url = this.getChatUrl(`/channels/${reservationId}`);
    const { data: channel } = await this.http.post(url, null);
    return channel;
  }

  async getChannels(onlyActive = true) {
    const { data: channels } = await this.http.get(this.getChatUrl('/channels'));

    return onlyActive ?
      channels.filter(ch => ch.has_guest_member === true) :
      channels;
  }

  async getToken() {
    const options = {
      params: {
        appInstallId: this.session.getAffiliateId(), // TODO: use real appInstallId
      },
    };

    const { data } = await this.http.post(this.getChatUrl('/token'), null, options);
    return data;
  }
}

inject(MojitoService, ['ApiFactory', 'SessionService']);
export default MojitoService;



// WEBPACK FOOTER //
// ./src/services/MojitoService.js